module.exports = __webpack_public_path__ + "img/sandglass.45fe470c.svg";